import {
  ReportFilter,
  ReportFilterGroup,
  ReportFilterOperation,
  ReportValue,
} from '@driftt/api-types'

import { createFilter } from './creators'

export default class FilterGroupBuilder {
  public shouldMatch = 1
  public negateFilterGroup = false
  public filters: ReportFilter[] = []
  public filterGroups?: ReportFilterGroup[]

  public withFilter(
    property: string,
    operation: ReportFilterOperation,
    value: ReportValue | ReportValue[] | null = null
  ) {
    this.filters.push(createFilter(property, operation, value))
    return this
  }

  public withFilterGroup(filterGroup: ReportFilterGroup) {
    if (!this.filterGroups) {
      this.filterGroups = []
    }
    this.filterGroups.push(filterGroup)
    return this
  }

  public withShouldMatch(shouldMatch: number) {
    this.shouldMatch = shouldMatch
    return this
  }

  public withNegateFilterGroup(negateFilterGroup: boolean) {
    this.negateFilterGroup = negateFilterGroup
    return this
  }

  public build(): ReportFilterGroup {
    const filterGroup: ReportFilterGroup = {
      shouldMatch: this.shouldMatch,
      negateFilterGroup: this.negateFilterGroup,
      filters: this.filters,
    }

    if (this.filterGroups) {
      filterGroup.filterGroups = this.filterGroups
    }

    return filterGroup
  }
}
